import React from 'react';
import type { Adapter } from '../types';
import SectionFrameMolecule from '../../components/molecules/SectionFrame/SectionFrameMolecule';

/** `Section` catalog entry adapter — one named region wrapping a single child subtree. */
const SectionAdapter: Adapter = ({ componentId, props, ctx }) => {
  const title = props.title !== undefined ? (ctx.resolveValue(props.title) as React.ReactNode) : undefined;
  const childId = typeof props.child === 'string' ? props.child : undefined;

  return (
    <SectionFrameMolecule componentId={componentId} title={title}>
      {childId ? ctx.renderChild(childId) : null}
    </SectionFrameMolecule>
  );
};

export default SectionAdapter;
